import { useEffect } from "react";

import { Opco } from "types/Opco";

import { getEnvFromHost } from "utils/getEnvFromHost";
import getOpco from "utils/getOpco";

const ENABLED_OPCOS = {
  DIT: ["es", "gb", "de", "lw", "eg", "pt", "za", "ro", "cz", "tr", "gr", "nl"],
  PRE: ["es", "gb", "de", "lw", "eg", "pt", "za", "ro", "cz", "tr", "gr", "nl"],
  PROD: ["es", "gb", "de", "lw", "eg", "pt", "cz", "ro", "tr", "gr", "za", "nl"],
};

const useOpcoGatekeeper = () => {
  const opco: Opco = getOpco();

  const {
    location: { host },
  } = window;

  const ENV = getEnvFromHost(host);

  useEffect(() => {
    if (!opco || (opco && ENABLED_OPCOS[ENV].indexOf(opco) < 0)) {
      window.location.replace("https://offers.vodafone.com/page-not-found");
    }
  }, [ENV, opco]);
};

export default useOpcoGatekeeper;
